import useToggle from 'hooks/useToggle';
import { useState } from 'react';
import { ISelectedCompany } from '..';

export const useDownloadPdf = () => {
  const [selectedCompany, setSelectedCompany] = useState<ISelectedCompany>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [downloadError, toggleDownloadError] = useToggle(false);

  const [query, setQuery] = useState('');

  return {
    selectedCompany,
    setSelectedCompany,
    isOpen,
    setIsOpen,
    downloadError,
    toggleDownloadError,
    query,
    setQuery,
  };
};
